import { Helmet } from 'react-helmet-async'

interface SEOHeadProps {
  title?: string
  description?: string
  image?: string
  url?: string
  type?: 'website' | 'article'
}

export default function SEOHead({
  title = 'LUKHAS AI - Consciousness-Aware Intelligence',
  description = 'LUKHAS AI is building the next generation of consciousness-aware AI systems with ethical governance and human-aligned intelligence.',
  image = 'https://lukhas.ai/assets/brand/media/og-image.svg',
  url = 'https://lukhas.ai',
  type = 'website',
}: SEOHeadProps) {
  const fullTitle = title.includes('LUKHAS') ? title : `${title} | LUKHAS AI`

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content="LUKHAS AI" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Canonical */}
      <link rel="canonical" href={url} />
    </Helmet>
  )
}
